import React, { ReactNode } from 'react';
import { ai } from '@sekoia/shared/utils/telemetryService';
import { useErrorBoundary } from 'react-use-error-boundary';
import ErrorPage from './ErrorPage';
import { Environment } from 'src/utils/environment';

type BaseErrorViewProps = {
  title: string;
  description: string;
  children: ReactNode;
  buttonText: string;
};

const BaseErrorView: React.FC<React.PropsWithChildren<BaseErrorViewProps>> = (props) => {
  const { title, description, children, buttonText } = props;
  const [error] = useErrorBoundary((error, errorInfo) =>
    ai.trackException({
      exception: new Error(`Error: ${error}, componentStack: ${errorInfo.componentStack}`),
    }),
  );

  if (error) {
    if (Environment.isDev) {
      return <ErrorPage buttonText={buttonText} shouldReload={true} title={title} description={`Error: ${error}`} />;
    } else {
      return <ErrorPage buttonText={buttonText} shouldReload={true} title={title} description={description} />;
    }
  }

  return <>{children}</>;
};

export default BaseErrorView;
